/// <amd-module name="TFS/Token/PatTokenPage/Components/PageLoadHandler" />
import { PanelActionCreator, PanelOperationType } from 'Actions/PanelActionCreator';
import { TokenActionCreator } from 'Actions/TokenActionCreator';
import { IPatPageContextValue, PatPageConsumer } from 'Context/PatPageContext';
import { TokenConfig } from 'Models/TokenConfig';
import * as React from 'react';
import { DisplayFilterOptions } from '../Contracts/Token';

export interface IOnInitialPageLoadProps {
}

export interface IOnInitialPageLoadInternalProps extends IOnInitialPageLoadProps {
    tokenAction: TokenActionCreator;
    panelAction: PanelActionCreator;
    tokenConfig: TokenConfig;
}

export class PageLoadHandlerInternal extends React.PureComponent<IOnInitialPageLoadInternalProps, {}> {
    constructor(props: IOnInitialPageLoadInternalProps) {
        super(props);
    }

    public componentDidMount(): void {
        this.initializePatTokenPage();

        // if param with token id exists, open edit dialog with that token
        const authorizationId = this.props.tokenConfig.getParamValueFromSearchParams("id");
        if (authorizationId) {
            this.retrieveTokenAndOpenDialog(authorizationId);
        }
    }

    public render() {
        return null;
    }

    public initializePatTokenPage = () => {
        const hostPageData = this.props.tokenConfig?.hostPageData;
        // start a fetch of the list
        this.props.tokenAction.resetTokens({
            status: DisplayFilterOptions.Active,
            organization: {
                id: hostPageData ? hostPageData.hostId : "",
                name: hostPageData ? hostPageData.hostName : "",
                url: hostPageData ? window.location.origin + hostPageData.hostPath : "",
            }
        });
    }

    private retrieveTokenAndOpenDialog = async (authoizationId: string) => {
        const token = await this.props.tokenAction.getToken(authoizationId);
        // only open dialog if a token is returned
        if (token) {
            this.props.panelAction.openTokenPanel(PanelOperationType.Edit, token);
        }
    }
}

export const PageLoadHandler = () => {
    return (
        <PatPageConsumer>
            {(patPageContext: IPatPageContextValue) =>
                <PageLoadHandlerInternal
                    tokenAction={TokenActionCreator.getInstance(patPageContext.pageContext)}
                    panelAction={PanelActionCreator.getInstance()}
                    tokenConfig={TokenConfig.getInstance(patPageContext.pageContext)}
                />
            }
        </PatPageConsumer>
    )
}
